import { FactsUrlStructureFactory } from "@factory/FactsUrlStructureFactory";

import { FactsStructureType_insuranceHandbookPageCollection_items } from "globalQueries/contentfulTypes/FactsStructureType";
import { UrlStructureItem } from "types/UrlStructureItem";

export const mappedFactsUrlStructure = (
  items: Array<FactsStructureType_insuranceHandbookPageCollection_items>,
): UrlStructureItem[] => {
  return items?.length ? FactsUrlStructureFactory(items) : ({} as UrlStructureItem[]);
};
